import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from 'react-redux'

import {getCartId} from '../../selectors/SimpleSelectors'
import PriceListingRow from "../../components/PriceListingRow";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faQuestionCircle} from "@fortawesome/pro-light-svg-icons/faQuestionCircle";
import {getCartSummary} from "../../selectors/Cart";
import ReactTooltip from 'react-tooltip'
import {dsgvoArticles} from "../../config/Config";

class CartView extends Component {

    static propTypes = {
        onViewUpdate: PropTypes.func
    }

    componentDidUpdate(prevProps, prevState) {

        if (this.props.onViewUpdate && prevProps.cartSummary !== this.props.cartSummary) {
            this.props.onViewUpdate()
        }
        ReactTooltip.rebuild()

    }


    shouldComponentUpdate(nextProps, nextState) {

        if (nextProps.cartIsSwappingProgress) {
            return false
        }

        return this.props.cartSummary !== nextProps.cartSummary || this.props.cartIsSwapping !== nextProps.cartIsSwapping
    }


    render() {

        const cartSummary = this.props.cartSummary

        return (
            <div className="cart-view">
                <div className="cart-view__header">
                    <h3>Deine Tarifübersicht</h3>
                    {(this.props.isFetching || this.props.isFetchingFormData) && <div className="cart-view__spinner">
					 <div className="spinner"/>
					 </div>}
                </div>
                <h4>
                    Aktuelle Konfiguration
                </h4>
                <div className={"cart-view__content"}>
                    {cartSummary.baseArticleInCart ? <div className={"cart-view__articles__article"} key={"cw_" + cartSummary.baseArticle.articleNumber}>
                        {cartSummary.baseArticle.priceMonthly ? <PriceListingRow
                            title={cartSummary.baseArticle.title}
                            price={Number(cartSummary.baseArticle.priceMonthly).toFixed(2) + " €"}
                            monthly={true}
                            tax={true}
                            caption={cartSummary.baseArticle.description}
                        /> : null}
                        {cartSummary.baseArticle.setupFee ? <PriceListingRow
                            className={"cart-view__articles__article--setup"}
                            title={cartSummary.baseArticle.billingPeriod === 0 ? cartSummary.baseArticle.title : "Einrichtungsgebühr"}
                            price={Number(cartSummary.baseArticle.setupFee).toFixed(2) + " €"}
                            tax={true}
                            caption={cartSummary.baseArticle.billingPeriod === 0 ? "" : cartSummary.baseArticle.title}
                        /> : null}
                    </div> : null}
                    {cartSummary.articleOptions.map(articleOption => {
                        return (
                            <div className={"cart-view__articles__article"} key={"cw_" + articleOption.articleNumber}>
                                {articleOption.priceMonthly ? <PriceListingRow
                                    title={articleOption.title}
                                    price={Number(articleOption.priceMonthly).toFixed(2) + " €"}
                                    monthly={true}
                                    tax={true}
                                    caption={articleOption.inclusiveStorage ? ((articleOption.inclusiveStorage / 1024 / 1024) + " GB inkl.") : ""}
                                /> : null}
                                {articleOption.setupFee ? <PriceListingRow
                                    className={"cart-view__articles__article--setup"}
                                    title={"Einrichtungsgebühr"}
                                    price={Number(articleOption.setupFee).toFixed(2) + " €"}
                                    tax={true}
                                    caption={articleOption.title}
                                /> : null}
                                {!articleOption.setupFee && !articleOption.priceMonthly ? <PriceListingRow
                                    title={articleOption.title}
                                    price={"0.00 €"}
                                    monthly={true}
                                    tax={true}
                                    caption={articleOption.inclusiveStorage ? ((articleOption.inclusiveStorage / 1024 / 1024) + " GB inkl.") : ""}
                                /> : null}
                            </div>
                        )
                    })}
                    {cartSummary.domains.map(domainDataEntry => {

                        const domainTitle = <div>{domainDataEntry.domainName}<span className="bold">{"." + domainDataEntry.domainEnding}</span></div>;

                        return (
                            <div className={"cart-view__domains__domain"} key={domainDataEntry.domainName + domainDataEntry.domainEnding}>
                                <PriceListingRow
                                    title={domainTitle}
                                    price={Number(domainDataEntry.priceMonthly).toFixed(2) + " €"}
                                    tax={true}
                                    monthly={true}
                                    caption={domainDataEntry.isInclusiveDomain ? "Inklusivdomain" : "Monatliche Kosten"}
                                />
                                {domainDataEntry.setupFee ? <PriceListingRow
                                    className={"cart-view__domains__domain--setup"}
                                    title={"Einrichtungsgebühr"}
                                    price={Number(domainDataEntry.setupFee).toFixed(2) + " €"}
                                    tax={true}
                                    caption={domainTitle}
                                /> : null}
                            </div>
                        )
                    })}
                </div>
                <div className={"cart-view__total"}>
                    <div className={"cart-view__total__step"}>
                        <PriceListingRow
                            title={"Gesamt einmalig"}
                            tax={true}
                            price={Number(cartSummary.total.setupFee).toFixed(2) + " €"}
                        />
                        <PriceListingRow
                            title={"Gesamt monatlich"}
                            tax={true}
                            price={Number(cartSummary.total.priceMonthly).toFixed(2) + " €"}
                        />
                    </div>
                    {cartSummary.total.freeRuntime > 0 ?
                        <div className={"cart-view__total__step"}><PriceListingRow
                            title={"Laufzeitrabatt"}
                            tax={true}
                            caption={cartSummary.total.freeRuntime + (cartSummary.total.freeRuntime === 1 ? " Monat" : " Monate") + " kostenfreie Laufzeit"}
                            promotion={true}
                            price={Number((-1 * cartSummary.total.freeRuntime) * cartSummary.baseArticle.priceMonthly).toFixed(2) + " €"}
                        /></div> : null}
                </div>
                {this.props.cartIsTesting ? <div className={"cart-view__test testing-tooltip"}>
                    <div className={"cart-view__test__text"}>
                        Kostenloser Test für 10 Tage
                    </div>
                    <div className={"cart-view__test__tooltip"} data-tip={"Das Paket kann während des Testzeitraums jederzeit im Kundencenter (login.mittwald.de) gekündigt werden."}
                         data-effect={"solid"} data-for={"global"}>
                        <FontAwesomeIcon
                            icon={faQuestionCircle}
                        />
                    </div>
                </div> : null}
            </div>
        )

    }

}

const mapStateToProps = (state) => {

    const cartSummary = getCartSummary(state)

    return {
        isFetching: state.cart.isFetching,
        isFetchingFormData: state.appState.isFetchingFormData,
        cartId: getCartId(state),
        cartSummary: cartSummary,
        cartIsTesting: state.cart.testing,
        cartIsAvManager: cartSummary.baseArticleInCart ? dsgvoArticles.includes("" + cartSummary.baseArticle.articleNumber) : false,
        cartIsSwapping: state.cart.isSwapping,
        cartIsSwappingProgress: state.cart.isSwappingProgress
    }

}


const mapDispatchToProps = (dispatch, getState) => {

    return {}

}

export default connect(mapStateToProps, mapDispatchToProps)(CartView)



/** WEBPACK FOOTER **
 ** ./src/containers/cart/CartView.js
 **/